import { Form, Input } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../../../components/DraggableModal";
import { EntEntityTypes } from "../../../../../models/handBooks/entityTypes";

enum TypeField {
    shortNameKy,
    shortNameRu,
    nameKy,
    nameRu,
    alias,
}

interface IProps {
    show: boolean;
    entityType: EntEntityTypes;
    onHide: () => void;
    onSubmit: (pos: EntEntityTypes) => Promise<boolean>;
}

export const AddEntityTypesModal = (props: IProps) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (props.show) setFieldsFromEntity();
    }, [props.show]);

    const setFieldsFromEntity = (): void => {
        form.setFields([
            { name: TypeField.shortNameKy, value: props.entityType.shortNameKy },
            { name: TypeField.shortNameRu, value: props.entityType.shortNameRu },
            { name: TypeField.nameKy, value: props.entityType.nameKy },
            { name: TypeField.nameRu, value: props.entityType.nameRu },
            { name: TypeField.alias, value: props.entityType.alias },
        ]);
    }

    const setEntityFromFields = (): EntEntityTypes => {
        let res = _.cloneDeep(props.entityType);
        res.shortNameKy = form.getFieldValue(TypeField.shortNameKy);
        res.shortNameRu = form.getFieldValue(TypeField.shortNameRu);
        res.nameKy = form.getFieldValue(TypeField.nameKy);
        res.nameRu = form.getFieldValue(TypeField.nameRu);
        res.alias = form.getFieldValue(TypeField.alias);
        return res;
    }

    const handleSubmit = async () => {
        setLoading(true);
        try {
            await form.validateFields();
            const data = setEntityFromFields();
           
            const result = await props.onSubmit(data);

            if (result) props.onHide();
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <DraggableModal
                title={props.entityType.id === null ? t('mechanisation.organizational_and_legal_forms.add_organizational_and_legal_forms') : t('mechanisation.organizational_and_legal_forms.edit_organizational_and_legal_forms')}
                visible={props.show}
                onCancel={props.onHide}
                onSubmit={handleSubmit}
                submitLoading={loading}
            >
                <Form
                    initialValues={{ remember: true }}
                    autoComplete="off"
                    layout="vertical"
                    form={form}
                >
                    <Form.Item
                        label={t('general.code')}
                        name={TypeField.alias}
                        rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                    <Form.Item
                        label={t('mechanisation.organizational_and_legal_forms.fullNameKy')}
                        name={TypeField.nameKy}
                        rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                    <Form.Item
                        label={t('mechanisation.organizational_and_legal_forms.fullNameRu')}
                        name={TypeField.nameRu}
                        rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                    <Form.Item
                        label={t('mechanisation.organizational_and_legal_forms.shortNameKy')}
                        name={TypeField.shortNameKy}
                        rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                    <Form.Item
                        label={t('mechanisation.organizational_and_legal_forms.shortNameRu')}
                        name={TypeField.shortNameRu}
                        rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
                    >
                        <Input autoComplete="off" />
                    </Form.Item>

                </Form>
            </DraggableModal>
        </>
    )
}
